import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'wordDeclension', standalone: true })
export class WordDeclensionPipe implements PipeTransform {
  transform(quantity: number, declensions: string[]): string {
    const cases = [2, 0, 1, 1, 1, 2];

    return (
      quantity +
      ' ' +
      declensions[
        quantity % 100 > 4 && quantity % 100 < 20 ? 2 : cases[quantity % 10 < 5 ? quantity % 10 : 5]
      ]
    );
  }
}
